import React from 'react'
import Typography from '@mui/material/Typography'
import Template from '../layout/Template'

const MediaQueryPageContainer = () => (
  <Template>
    <Typography className='text-max text-center'>We will be available in mobile version soon</Typography>
  </Template>
)

export default MediaQueryPageContainer
